import React from "react";

import useAPMAdvisorIdentify from "@src/multiCustodian/hooks/Advisor/useAPMAdvisorIdentify";

export default function APMAdvisorIdentify(): JSX.Element {
  useAPMAdvisorIdentify();

  return <></>;
}
